module.exports = {
          srcSet: __webpack_public_path__ + "public/images/733207dfe233994de459658c57646843-380.jpg"+" 380w",
          images:[ {path: __webpack_public_path__ + "public/images/733207dfe233994de459658c57646843-380.jpg",width: 380,height: 253}],
          src: __webpack_public_path__ + "public/images/733207dfe233994de459658c57646843-380.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/733207dfe233994de459658c57646843-380.jpg"},
          
          width: 380,
          height: 253
        }